import { useMutation, useQuery } from '@apollo/client';
import { Card, Container, Stack, Typography } from '@mui/material';
import { FormSubmitRow } from 'components/common/form/submit-row';
import { CampaignSummaryQuery } from 'components/views/_shared-queries/campaign.graphql';
import { CreateDncMutation } from 'components/views/campaign/dnc/create-dnc.graphql';
import { useSnackbar } from 'providers/snackbar';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { CampaignSummary, CampaignSummaryVariables } from 'types/apollo/CampaignSummary';
import { CreateDnc, CreateDncVariables } from 'types/apollo/CreateDnc';
import { FormTextField } from '../../forms/form-text-field';

interface FormData {
  phone: string;
}

const phoneRegExp = /^\+\d{11}$/g;

export const CampaignDnc: FC = () => {
  const { campaignId: id } = useParams();
  const { openSnackbar } = useSnackbar();
  const { data } = useQuery<CampaignSummary, CampaignSummaryVariables>(CampaignSummaryQuery, {
    variables: {
      campaignId: id ?? '0',
    },
  });

  const form = useForm<FormData>({
    defaultValues: {
      phone: '',
    },
  });

  const [createDnc] = useMutation<CreateDnc, CreateDncVariables>(CreateDncMutation);

  const onSubmit = form.handleSubmit(async (input) => {
    const campaignId = data?.campaign?.id;
    if (!campaignId) return;
    try {
      await createDnc({
        variables: {
          input: {
            campaignId,
            phone: input.phone,
          },
        },
      });
      openSnackbar({ message: 'DNC phone successfully added', severity: 'success' });
      form.reset();
    } catch (err) {
      // caught in GraphQLWrapper
    }
  });

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          p: {
            xs: 2,
            md: 3,
          },
        }}
      >
        <form onSubmit={onSubmit}>
          <FormProvider {...form}>
            <Card variant="outlined" sx={{ padding: '16px' }}>
              <Stack spacing={2}>
                <Typography variant="h5">DNC Lead</Typography>
                <FormTextField
                  form={form}
                  name="phone"
                  customValidate={phoneRegExp}
                  customValidateMessage="Must be properly formatted phone like +12345554321"
                  helperText="Format: +15554329876"
                  variant="standard"
                />
              </Stack>
            </Card>
            <FormSubmitRow sx={{ marginTop: 2 }} onCancel={() => form.reset()} />
          </FormProvider>
        </form>
      </Container>
    </>
  );
};
